import { Box, Td, Tr } from "@chakra-ui/react";
import { Ask, Response } from "core";

import React from "react";
import TableCard from "../../../../components/TableCard";
import { WithId } from "../../../../types/utils";
import AskRow, { columnNames as askColumnNames } from "../AskRow";

interface Props {
  response: Response;
  asks: WithId<Ask>[];
}

export default function ResponseTab({ response, asks }: Props) {
  return (
    <Box>
      <TableCard mb={4} columnNames={askColumnNames} title="Asks">
        {asks.map((ask) => (
          <AskRow ask={ask} isLast={ask.id === asks[asks.length - 1].id} />
        ))}
      </TableCard>

      {response.linkedinUser ? (
        <TableCard
          mb={4}
          columnNames={["Field", "Value"]}
          title="LinkedIn data"
        >
          <Tr>
            <Td>Headline</Td>
            <Td>{response.linkedinUser?.headline}</Td>
          </Tr>
          <Tr>
            <Td>Certifications</Td>
            <Td>
              {response.linkedinUser?.certifications?.map(({ name }) => name)}
            </Td>
          </Tr>
          <Tr>
            <Td>Experiences</Td>
            <Td>
              {response.linkedinUser?.experiences?.map(({ title, company }) => (
                <p>{JSON.stringify({ title, company })}</p>
              ))}
            </Td>
          </Tr>

          <Tr>
            <Td>Languages</Td>
            <Td>{response.linkedinUser?.languages}</Td>
          </Tr>
          <Tr>
            <Td>Volunteer work</Td>
            <Td>
              {response.linkedinUser?.volunteer_work?.map(
                ({ title, description, company }) => (
                  <p>{JSON.stringify({ title, description, company })}</p>
                )
              )}
            </Td>
          </Tr>
          <Tr>
            <Td>Education</Td>
            <Td>
              {response.linkedinUser?.education?.map(
                ({ degree_name, field_of_study, school }) => (
                  <p>
                    {JSON.stringify({
                      degree_name,
                      field_of_study,
                      school,
                    })}
                  </p>
                )
              )}
            </Td>
          </Tr>
        </TableCard>
      ) : null}
    </Box>
  );
}
